enum ActionTypes {
  ActionShowError = 'ActionShowError',
  ActionClearError = 'ActionClearError',
  ActionLoginToCheckout = 'ActionLoginToCheckout',
  ActionCreateCheckoutCustomer = 'ActionCreateCheckoutCustomer',
  ActionCreateCheckoutPurchase = 'ActionCreateCheckoutPurchase',
  ActionValidateDebitCard = 'ActionValidateDebitCard',
  ActionVerifySSN = 'ActionVerifySSN',
  ExtraVerification = 'ExtraVerification',
  MxError = 'Mx Error',
  GetLoanApplicationUrlError = 'Get loan application url error',
}

export default ActionTypes;
